import { IconPhone, IconSuitcase } from '@maia/icons';
import { SpecList, Typography, cardStyles } from '@maia/ui';
import { twMerge } from 'tailwind-merge';

type Props = {
  name: string;
  jobTitle: string;
  email: string | null;
  phone: string | null;
};

export function ClaimHandlerInformation(props: Props) {
  const { name, jobTitle, email, phone } = props;

  return (
    <div className="flex flex-col gap-y-24">
      <div className="flex flex-row items-center gap-x-12">
        <IconSuitcase className="min-w-24 w-24 h-24 fill-primaryMain" />

        <div className="flex flex-col">
          <Typography
            variant="body-xs"
            weight="medium"
            className="text-primaryMain"
          >
            {name}
          </Typography>

          <Typography
            variant="body-xs"
            weight="regular"
            className="text-grayscale300"
          >
            {jobTitle}
          </Typography>
        </div>
      </div>

      {(email || phone) && (
        <div className={twMerge(cardStyles({ variant: 'flat' }), 'p-12')}>
          <SpecList
            items={[
              ...(email ? [{ icon: IconPhone, title: email }] : []),
              ...(phone ? [{ icon: IconPhone, title: phone }] : []),
            ]}
          />
        </div>
      )}
    </div>
  );
}
